import React from 'react';
import { Row, Col } from 'seduo-ui';
import HighlightItemExample from './HighlightItem';
export default class Example extends React.Component {
    render() {
        return (<div className="highlight-list">
                <div className="container">
                    <Row>
                        <Col xs={6} md={3}>
                            <HighlightItemExample />
                        </Col>
                        <Col xs={6} md={3}>
                            <HighlightItemExample />
                        </Col>
                        <Col xs={6} md={3}>
                            <HighlightItemExample />
                        </Col>
                        <Col xs={6} md={3}>
                            <HighlightItemExample />
                        </Col>
                    </Row>
                </div>
            </div>);
    }
}
